import { render, staticRenderFns } from "./trajet-global.vue?vue&type=template&id=60089891"
import script from "./trajet-global.vue?vue&type=script&lang=js"
export * from "./trajet-global.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports